import * as React from "react";

import { noop } from "../../../../../Common/TypingUtils";

const AddSingleUnitContextObject = React.createContext<() => void>(noop);

export const AddSingleUnitContextProvider = AddSingleUnitContextObject.Provider;

export function useAddSingleUnit(): () => void {
    return React.useContext(AddSingleUnitContextObject);
}
